import { platformHttpClient } from "@/shared/api/platform-http-client";
import type { TenantDiscoveryResponse } from "@/features/auth/model/tenant-discovery";

export async function discoverTenant(email: string): Promise<TenantDiscoveryResponse> {
  return platformHttpClient.post<TenantDiscoveryResponse>("/v1/auth/tenant-discovery", {
    email,
  });
}
